import React from 'react';
import TischOffensives from './TischOffensives';
import {
  OutdoorClusters, SkiClusters, BikeClusters, UnisexClusters,
} from './Clusters';
import { RowFlexBox, SpacingBox } from '../Components';
import { DropdownPanel } from './DropdownPanel';

const TopMenuItem = ({ children }) => (
  <SpacingBox marginRight="xl">{children}</SpacingBox>
);

// Dropdown below the topbar, opened by hovering the genres (see GenrePicker)
export const TopMenuModal = ({
  isOpen, genre, anchorRef, triggerRef, onClose, onMouseEnter, onMouseLeave,
}) => (
  <DropdownPanel
    isOpen={isOpen}
    anchorRef={anchorRef}
    triggerRef={triggerRef}
    onClose={onClose}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}>
    {/* Same nesting as the topbar - both classes on one element overflow */}
    <div className="margin-10p">
      <div className="container-fluid">
        <RowFlexBox flex={1}>
          <TopMenuItem>
            <BikeClusters genre={genre} onSelectCluster={onClose} />
          </TopMenuItem>
          <TopMenuItem>
            <OutdoorClusters genre={genre} onSelectCluster={onClose} />
          </TopMenuItem>
          <TopMenuItem>
            <SkiClusters genre={genre} onSelectCluster={onClose} />
          </TopMenuItem>
          <TopMenuItem>
            <UnisexClusters onSelectCluster={onClose} />
          </TopMenuItem>
          <TopMenuItem>
            <TischOffensives onSelect={onClose} />
          </TopMenuItem>
        </RowFlexBox>
      </div>
    </div>
  </DropdownPanel>
);
